import script from "./FAQCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQCard.vue?vue&type=script&setup=true&lang=js"

import "./FAQCard.vue?vue&type=style&index=0&id=7a960fe6&scoped=true&lang=css"

import exportComponent from "/data/gitlab-runner/builds/hunterretail/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a960fe6"]])

export default __exports__